function unusable(name) {
  var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'algorithm.name';
  return new TypeError("CryptoKey does not support this operation, its ".concat(prop, " must be ").concat(name));
}
function isAlgorithm(algorithm, name) {
  return algorithm.name === name;
}
function getHashLength(hash) {
  return parseInt(hash.name.slice(4), 10);
}
function getNamedCurve(alg) {
  switch (alg) {
    case 'ES256':
      return 'P-256';
    case 'ES384':
      return 'P-384';
    case 'ES512':
      return 'P-521';
    default:
      throw new Error('unreachable');
  }
}
function checkUsage(key, usages) {
  if (usages.length && !usages.some(function (expected) {
    return key.usages.includes(expected);
  })) {
    var msg = 'CryptoKey does not support this operation, its usages must include ';
    if (usages.length > 2) {
      var last = usages.pop();
      msg += "one of ".concat(usages.join(', '), ", or ").concat(last, ".");
    } else if (usages.length === 2) {
      msg += "one of ".concat(usages[0], " or ").concat(usages[1], ".");
    } else {
      msg += "".concat(usages[0], ".");
    }
    throw new TypeError(msg);
  }
}
export function checkSigCryptoKey(key, alg) {
  switch (alg) {
    case 'HS256':
    case 'HS384':
    case 'HS512':
      {
        if (!isAlgorithm(key.algorithm, 'HMAC')) throw unusable('HMAC');
        var expected = parseInt(alg.slice(2), 10);
        var actual = getHashLength(key.algorithm.hash);
        if (actual !== expected) throw unusable("SHA-".concat(expected), 'algorithm.hash');
        break;
      }
    case 'RS256':
    case 'RS384':
    case 'RS512':
      {
        if (!isAlgorithm(key.algorithm, 'RSASSA-PKCS1-v1_5')) throw unusable('RSASSA-PKCS1-v1_5');
        var _expected = parseInt(alg.slice(2), 10);
        var _actual = getHashLength(key.algorithm.hash);
        if (_actual !== _expected) throw unusable("SHA-".concat(_expected), 'algorithm.hash');
        break;
      }
    case 'PS256':
    case 'PS384':
    case 'PS512':
      {
        if (!isAlgorithm(key.algorithm, 'RSA-PSS')) throw unusable('RSA-PSS');
        var _expected2 = parseInt(alg.slice(2), 10);
        var _actual2 = getHashLength(key.algorithm.hash);
        if (_actual2 !== _expected2) throw unusable("SHA-".concat(_expected2), 'algorithm.hash');
        break;
      }
    case 'EdDSA':
      {
        if (key.algorithm.name !== 'Ed25519' && key.algorithm.name !== 'Ed448') {
          throw unusable('Ed25519 or Ed448');
        }
        break;
      }
    case 'Ed25519':
      {
        if (!isAlgorithm(key.algorithm, 'Ed25519')) throw unusable('Ed25519');
        break;
      }
    case 'ES256':
    case 'ES384':
    case 'ES512':
      {
        if (!isAlgorithm(key.algorithm, 'ECDSA')) throw unusable('ECDSA');
        var _expected3 = getNamedCurve(alg);
        var _actual3 = key.algorithm.namedCurve;
        if (_actual3 !== _expected3) throw unusable(_expected3, 'algorithm.namedCurve');
        break;
      }
    default:
      throw new TypeError('CryptoKey does not support this operation');
  }
  for (var _len = arguments.length, usages = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    usages[_key - 2] = arguments[_key];
  }
  checkUsage(key, usages);
}
export function checkEncCryptoKey(key, alg) {
  switch (alg) {
    case 'A128GCM':
    case 'A192GCM':
    case 'A256GCM':
      {
        if (!isAlgorithm(key.algorithm, 'AES-GCM')) throw unusable('AES-GCM');
        var expected = parseInt(alg.slice(1, 4), 10);
        var actual = key.algorithm.length;
        if (actual !== expected) throw unusable(expected, 'algorithm.length');
        break;
      }
    case 'A128KW':
    case 'A192KW':
    case 'A256KW':
      {
        if (!isAlgorithm(key.algorithm, 'AES-KW')) throw unusable('AES-KW');
        var _expected4 = parseInt(alg.slice(1, 4), 10);
        var _actual4 = key.algorithm.length;
        if (_actual4 !== _expected4) throw unusable(_expected4, 'algorithm.length');
        break;
      }
    case 'ECDH':
      {
        switch (key.algorithm.name) {
          case 'ECDH':
          case 'X25519':
          case 'X448':
            break;
          default:
            throw unusable('ECDH, X25519, or X448');
        }
        break;
      }
    case 'PBES2-HS256+A128KW':
    case 'PBES2-HS384+A192KW':
    case 'PBES2-HS512+A256KW':
      if (!isAlgorithm(key.algorithm, 'PBKDF2')) throw unusable('PBKDF2');
      break;
    case 'RSA-OAEP':
    case 'RSA-OAEP-256':
    case 'RSA-OAEP-384':
    case 'RSA-OAEP-512':
      {
        if (!isAlgorithm(key.algorithm, 'RSA-OAEP')) throw unusable('RSA-OAEP');
        var _expected5 = parseInt(alg.slice(9), 10) || 1;
        var _actual5 = getHashLength(key.algorithm.hash);
        if (_actual5 !== _expected5) throw unusable("SHA-".concat(_expected5), 'algorithm.hash');
        break;
      }
    default:
      throw new TypeError('CryptoKey does not support this operation');
  }
  for (var _len2 = arguments.length, usages = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    usages[_key2 - 2] = arguments[_key2];
  }
  checkUsage(key, usages);
}